import { render, staticRenderFns } from "./product.vue?vue&type=template&id=80343ee6&scoped=true&"
var script = {}
import style0 from "./product.vue?vue&type=style&index=0&id=80343ee6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80343ee6",
  null
  
)

export default component.exports